import ResizeObserver from 'resize-observer-polyfill';
import { renderTemplate } from './utilities';
import template from '../templates/global-menu-container.tpl.html';
import closeIcon from '../assets/images/icons/close.svg';

export default class GlobalMenuContainer {

  constructor(element) {
    this.element = element;
    this.buttons = [];
    this.closeIcon = closeIcon;

    this.render(template);
  }

  render(template) {
    const renderedTemplate = renderTemplate(template, this);
    renderedTemplate.hidden = true;

    this.element.innerHTML = ''; // Clear the wrapping element...
    this.element.appendChild(renderedTemplate);
  }

  observe() {
    this._boundCloseButtonHandler = this.handleClose.bind(this);
    this.closeButtonElement = this.element.querySelector('.global-menu-close');
    this.closeButtonElement.addEventListener('click', this._boundCloseButtonHandler);
    this.panelBackdrop = this.element.querySelector('.dt-gnm-menu-background > div');
    this.panelBackdrop.addEventListener('click', this._boundCloseButtonHandler);
    this.resizeObserver.observe(this.element);
  }

  unobserve() {
    if (this.closeButtonElement) {
      this.closeButtonElement.removeEventListener('click', this._boundCloseButtonHandler);
    }
    if (this.panelBackdrop) {
      this.panelBackdrop.removeEventListener('click', this._boundCloseButtonHandler);
    }
    this._boundCloseButtonHandler = null;
    this.resizeObserver.unobserve(this.element);
  }

  destroy() {
    this.unobserve();
    this.resizeObserver.disconnect();
  }

  closeOtherButtons(currentButton) {
    this.buttons.forEach((button) => {
      if (button !== currentButton) {
        button.close();
      }
    });
  }

  open(buttonInstance) {
    var self = this;
    if (this.menuRoot.hidden === false) {
      this.close();
      setTimeout(function() {
        self.continueOpen(buttonInstance);
      }, 250);
    } else {
      this.continueOpen(buttonInstance);
    }
  }

  continueOpen(buttonInstance) {

    this.currentButtonInstance = buttonInstance;
    this.closeOtherButtons(buttonInstance);
    this.itemsContainer.classList.add(buttonInstance.cssClass);
    this.itemsContainer.innerHTML = ''; // Clear the container...
    this.resize();
    buttonInstance.menuItems.forEach((x) => this.itemsContainer.appendChild(x));

    this.menuRoot.hidden = false;
    this.observe();
  }

  close() {
    this.menuRoot.hidden = true;
    if (this.currentButtonInstance) {
      this.itemsContainer.classList.remove(this.currentButtonInstance.cssClass);
    }
  }

  handleClose() {
    this.unobserve();
    this.currentButtonInstance.close();
  }

  resize() {
    if (this.itemsContainer.classList.contains('global-menu')) {
      this.itemsContainer.style.maxWidth = `${this.maxWidth}px`;
    } else {
      this.itemsContainer.style.maxWidth = null;
    }
  }

  get menuRoot() {
    return this._menuRoot = this._menuRoot || (
      this.element.querySelector('.dt-gnm-menu-root')
    );
  }

  get overlayElement() {
    return this._overlayElement = this._overlayElement || (
      this.element.querySelector('.dt-gnm-menu-background')
    );
  }

  get menuContainer() {
    return this._menuContainer = this._menuContainer || (
      this.element.querySelector('.dt-gnm-menu-panel')
    );
  }

  get itemsContainer() {
    return this._itemsContainer = this._itemsContainer || (
      this.element.querySelector('.dt-gnm-menu-items')
    );
  }

  get resizeObserver() {
    return this._resizeObserver = this._resizeObserver || (
      new ResizeObserver(this.resize.bind(this))
    );
  }

  //
  // Calculates the maximum width of the menu items container by checking the
  // width of the element, which should be a relatively positioned block-level
  // element.
  //
  get maxWidth() {
    let maxWidth = 1176;
    const containerWidth = this.element.clientWidth;
    const maxItemsPerRow = parseInt((containerWidth - 60) / 372, 10);
    const calculatedMax = (maxItemsPerRow * 372) + 60;
    if (calculatedMax < maxWidth) {
      maxWidth = calculatedMax;
    }
    return maxWidth;
  }

}



// WEBPACK FOOTER //
// ./src/scripts/global-menu-container.js